import dayjs from "dayjs";
import { get } from "lodash";

const isToday = (date, today) => date.isSame(today, "day");
const isYesterday = (date, today) =>
  date.isSame(today.subtract(1, "day"), "day");

const DATE_FORMATTERS = {
  today: () => "Today",
  yesterday: () => "Yesterday",
  other: (date) => date.format("MMM DD, YYYY"),
};

const getDateType = (date, today) => {
  const dateChecks = [
    { condition: () => isToday(date, today), type: "today" },
    { condition: () => isYesterday(date, today), type: "yesterday" },
  ];

  const match = dateChecks.find((check) => check.condition());
  return get(match, "type", "other");
};

const formatDate = (timestamp) => {
  const date = dayjs(parseInt(timestamp));
  const today = dayjs();
  const dateType = getDateType(date, today);
  const formatter = get(DATE_FORMATTERS, dateType, DATE_FORMATTERS.other);

  return formatter(date);
};

export const groupByDate = (data, dateExtractor = "createdDate") => {
  return data.reduce((groups, item) => {
    const timestamp = get(item, dateExtractor);
    const formattedDate = formatDate(timestamp);

    return {
      ...groups,
      [formattedDate]: [...get(groups, formattedDate, []), item],
    };
  }, {});
};
